export default {
  component: {
    jobAdList: {
      title: 'الوظائف الشاغرة المتاحة.',
      jobs: 'الوظائف',
      noJobAds: 'لا توجد حاليا أي وظائف شاغرة . ',
    },

    jobAdCard: {
      openUntil: date => `التسجيل مفتوح إلى غاية ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'شكرًا لك.',
      readyInfo: 'لقد تم الآن استلام طلبك، وسيتواصل معك مسؤول التوظيف قريبًا.',
      luck: 'حظا سعيدا!',
    },

    jobAdSeeYou: {
      title: 'شكرًا لك.',
      description: 'تم حفظ طلبك، وقد  أرسلنا لك رابطًا لمتابعة تقديم طلبك لاحقًا.',
    },

    videoResponse: {
      videoPlaceholder: 'Record your response',
      submit: 'Submit response',
      notAnswered: 'You have not yet answered',
    },

    unpublished: {
      title: 'لم يعلن عن ذلك بعد.',
      info: 'الإعلان عن الوظيفة لم ينشر بعد.',
    },
  },

  page: {
  },

}
